import { MD3LightTheme as DefaultTheme } from 'react-native-paper'
import { ColorsEnum } from '../constants/colors'

export const theme = {
    ...DefaultTheme,
    colors: {
        ...DefaultTheme.colors,
        primary: ColorsEnum.PRIMARY,
        surface: '#FFFFFF',
    },
    roundness: 1,
}
